import { render, staticRenderFns } from "./184.vue?vue&type=template&id=6a6e0bc2&scoped=true&"
var script = {}
import style0 from "./184.vue?vue&type=style&index=0&id=6a6e0bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6e0bc2",
  null
  
)

export default component.exports